<script>
    import { useVuelidate } from '@vuelidate/core'
    export default {
        name: 'form-input-text',
        setup () { return { v$: useVuelidate() } },


        props: {
            value: {
                type: String,
                required: true
            },
            inputId: {
                type: String,
                required: false
            },
            inputType: {
                type: String,
                required: false
            },
            inputClass: {
                type: String,
                required: false
            },
            icon: {
                type: String,
                required: false
            },
            lazyValidation: {
                type: String,
                required: false
            },
            label: {
                type: String,
                default: ''
            },
            v: {
                type: Object,
                required: true
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            
            focus: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            text: {
                get() {
                    return this.value;
                },

                set(value) {
                    if (this.lazyValidation !== undefined && this.lazyValidation === "true")
                        this.v.$touch();
                    this.$emit("update:value", value);
                }
            },
            
            showIcon: function () {
                return this.myIcon !== undefined && this.myIcon !== null && this.myIcon.length > 0;
            },
            myInputType: {
                get() {
                    if (this.inputType !== undefined && this.inputType !== null && this.inputType.length > 0)
                        return this.inputType;
                    else return 'text';
                }
            },
            
            myIcon: function () {
                if (this.isSuccess())
                    return "icon-ok green";
                else return this.icon;
            }
           
            
        },

        mounted: function() {
            if (this.focus) {
                this.$refs.input.focus();
            }
        },
        methods: {
            isSuccess() {
                return !this.v$.$invalid && this.v$.$dirty;
            },
            onBlur(event) { 
                this.v.$touch();
                this.$emit('blur', event);
            }
        },
        emits:['blur','update:value']
    };
</script>

<template>

    <div class="form-group" :class="{'form-group-error' : v.$error, 'ok' : !v.$invalid && v.$dirty}">
        <i :class="{'icon-star': !(!v.$invalid && v.$dirty), 'icon-ok green': !v.$invalid && v.$dirty} " v-if="showIcon"></i>
        <input type="text" :id="inputId" :disabled="isDisabled" :type="myInputType" class="form-control" :class="inputClass" :placeholder="label" v-model="text" ref="input" @blur="onBlur($event)">
        <label :for="inputId" class="control-label">{{ label }}</label>
        <div v-for="error of v.$errors" :key="error.$uid">{{error.$message}}</div>
    </div>

</template>

<style lang="scss">
</style>